import CustomSpinner from "@/components/spinner/CustomSpinner";
import ErrorBoundary from "@/pages/error/errorBoundary/ErrorBoundary";
import { initLogger } from "@/services/log/initLogger";
import { mswSetup } from "@/services/system/mswSetup";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./app/App";
import store, { persistor } from "./app/stores/store";
import "./i18n/i18n";
import "./styles/font.scss";
import "./styles/style.scss";

mswSetup();
initLogger();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<CustomSpinner isFullScreen={true} />} persistor={persistor}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
